import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/seo")({
  head: () => ({ meta: [{ title: "SEO Settings | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-seo")),
});
